














































































import OptionSelect from "../../core/Forms/OptionSelect.vue";
import TextInput from "../../core/Forms/TextInput.vue";
import TextareaInput from "../../core/Forms/TextareaInput.vue";
import TextSettingChecker from "./TextSettingChecker.vue";
import { RelanceTemplateApi } from "../../api/RelanceTemplateApi";
import { RelanceTemplate } from "../../models/RelanceTemplate";

export default {
    name: "RelanceTemplatesFieldset",
    components: {
        OptionSelect,
        TextInput,
        TextareaInput,
        TextSettingChecker,
    },
    data() {
        return {
            RelanceTemplateApi: new RelanceTemplateApi(),
            levels: {},
            templates: {},
            currentLevel: 1,
            resetting: false,
            variables: RelanceTemplate.variables,
        };
    },
    created() {
        this.loadTemplates();
    },
    computed: {
        template() {
            return this.templates[this.currentLevel] || null;
        },
        isMail() {
            let level = this.levels[this.currentLevel];
            return !level || level.type === "mail";
        },
        levelOptions() {
            let options = {};
            _.each(this.levels, function (level, id) {
                options[id] = { id: _.toNumber(id), name: level.label };
            });
            return options;
        },
        // TextSettingChecker met la variable en vert dès qu'elle est présente
        // dans l'un des quatre champs du niveau courant.
        allFieldsText() {
            if (!this.template) return "";
            return _.values(this.template).join("\n");
        },
    },
    methods: {
        loadTemplates() {
            let self = this;
            return self.RelanceTemplateApi.getAll().then(function (res) {
                self.levels = res.levels;
                self.templates = res.templates;
            });
        },
        /** Appelé par AppSettings au moment de l'enregistrement global. */
        saveAll(): Array<Promise<any>> {
            let self = this;
            return _.map(self.templates, function (template, level) {
                return self.RelanceTemplateApi.save(
                    _.toNumber(level),
                    template
                );
            });
        },
        resetTemplate() {
            let self = this;
            let level = self.currentLevel;
            self.resetting = true;
            self.RelanceTemplateApi.reset(level)
                .then(function (template) {
                    self.$set(self.templates, level, template);
                    self.resetting = false;
                })
                .catch(function () {
                    self.resetting = false;
                });
        },
    },
};
